import { Component } from '@angular/core';

import { BaseIconComponent } from '../base-icon.component';

@Component({
  selector: 'app-business-rental-icon',
  template: `
    <svg
      [attr.width]="width"
      [attr.height]="height"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_522_2396)">
        <path
          d="M8.25 19.535H5.25C4.85218 19.535 4.47064 19.377 4.18934 19.0957C3.90804 18.8144 3.75 18.4328 3.75 18.035V10.535"
          [attr.stroke]="color"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M0.75 9.035L9.531 1.605C9.80185 1.37579 10.1452 1.25001 10.5 1.25001C10.8548 1.25001 11.1982 1.37579 11.469 1.605L18.748 7.764"
          [attr.stroke]="color"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M15.75 1.535H18.75V4.535"
          [attr.stroke]="color"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M15.64 18.21C15.6925 18.2624 15.7283 18.3292 15.7428 18.402C15.7573 18.4748 15.7499 18.5502 15.7215 18.6187C15.6931 18.6873 15.6451 18.7459 15.5834 18.7871C15.5217 18.8283 15.4492 18.8503 15.375 18.8503C15.3008 18.8503 15.2283 18.8283 15.1666 18.7871C15.1049 18.7459 15.0569 18.6873 15.0285 18.6187C15.0001 18.5502 14.9927 18.4748 15.0072 18.402C15.0217 18.3292 15.0575 18.2624 15.11 18.21C15.1447 18.1751 15.186 18.1474 15.2315 18.1285C15.277 18.1096 15.3258 18.0999 15.375 18.0999C15.4242 18.0999 15.473 18.1096 15.5185 18.1285C15.564 18.1474 15.6053 18.1751 15.64 18.21Z"
          stroke="#00D5D3"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M19.087 17L22.774 13.313C23.079 13.008 23.2503 12.5943 23.2503 12.163C23.2503 11.7317 23.079 11.318 22.774 11.013C22.469 10.708 22.0553 10.5367 21.624 10.5367C21.1927 10.5367 20.779 10.708 20.474 11.013L16.79 14.7C15.9217 14.36 14.9628 14.3292 14.0744 14.6129C13.1861 14.8966 12.4225 15.4774 11.912 16.2578C11.4015 17.0381 11.1752 17.9705 11.2711 18.898C11.367 19.8256 11.7793 20.6919 12.4387 21.3513C13.0981 22.0107 13.9644 22.423 14.892 22.5189C15.8195 22.6148 16.7519 22.3885 17.5322 21.878C18.3126 21.3675 18.8934 20.6039 19.1771 19.7156C19.4608 18.8272 19.43 17.8683 19.09 17H19.087Z"
          stroke="#00D5D3"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_522_2396">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  `,
})
export class BusinessRentalIconComponent extends BaseIconComponent {}
